// extracted by mini-css-extract-plugin
module.exports = {"row":"styles_row__E1SF9","skeleton-animation":"styles_skeleton-animation__zy4tN"};